export const getDefaultPositionShadowLayerStyle = (): TrimbleMaps.CirclePaint => {
  return {
    'circle-color': '#000',
    'circle-blur': 1.2,
    'circle-opacity': 0.5,
    'circle-radius': 13,
    'circle-translate': [0, 6],
  }
}
